<template>
  <div class="yybIndex" >
    <van-tabs v-model="active" sticky line-width="55px" line-height="3px">
      <van-tab title="全部">
        <div class="pageDiv">
          <div class="regionList">
            <div class="regionInfo"  v-for="(value, index) in regionList" :key="index" v-bind:class="{'regionSelected': yybActive==index}"  @click="getYybInfo(value,index)">{{value}}</div>
          </div>
          <div class="yybList" >
            <div class="yybInfo" v-for="(item, index) in yybList" :key="index">
              <div class="yybName">{{item.branchName}}<img @click="call(item.branchPhone)" class="phone" src="../../img/phone.png"></div>
              <div class="yybAdress">{{item.branchAddress}}</div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="附近">
          <div class="nearYybList" style="width:100%">
            <div class="yybInfo" v-for="(item, index) in nearList" :key="index">
              <div class="yybName">{{item.branchName}}<img @click="call(item.branchPhone)" class="phone" src="../../img/phone.png"></div>
              <div class="yybAdress">{{item.branchAddress}}</div>
              <div class="distance">距离{{item.distance}}公里</div>
            </div>
          </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<style>
body{
  height:100%;
  padding: 0;
  margin:0;
}

</style>
<script>
import { Sticky , Tab, Tabs } from "vant";
import "../../service/td-h5-hybird-sdk";
import  { getAppStorage,callPhone } from '../../service/bridge';
import { zzreq } from "../../api/interface";
export default {
  name: "klineindex",
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Sticky.name]: Sticky,
  },
  directives: {},
  data() {
    return {
      active: 0,
      yybActive:0,
      yybData:{},
      regionList:[],
      yybList:[],
      yybTempData:{},
      nearList:[],
      EARTH_RADIUS:6378.137,
      wd:'39.90920954',
      jd:'116.3973999'
    };
  },
// {data:[]}
  computed: {

  },
  activated() {
  },
  mounted() {
    //通过APP获取经纬度
    // this.jd="114.058563";
    // this.wd="22.54648";
    var that=this;
    getAppStorage(function(data){
      try{
        if(data.err_code=="0"){
          // console.log("========"+JSON.stringify(data))
          that.wd=data.data.latitude;
          console.log("========"+that.wd)
          that.jd=data.data.longitude;
          console.log("========"+that.jd)
        }
        that.getYYbData();
      }catch(e){
        that.getYYbData();
        console.log(e)
      }
    },"location");
    
  },
  updated() {},
  beforeDestroy() {},
  methods: {
    goTip() {
      this.$router.push({
        path: "/similarTip"
      });
    },
    getYybInfo(regionName,index){
      this.yybList=this.yybTempData[regionName];
      this.yybActive=index;
    },
    call(phone){
      callPhone(phone);
    },
    getYYbData(){
      //修改tab组件的高度，好适配正文部分的高度
    window.setTimeout(function(){
        document.getElementsByClassName("van-sticky")[0].parentNode.style.height="7%";
    },50);
    //通过中焯接口获取全部营业部信息
    zzreq("49200","&pageSize=200").then(data => {
      if(data.data && data.data.ERRORNO=="1"){
        this.yybData=JSON.parse(data.data.DATA).result;
        console.log(this.yybData)
        //全部tab页下的营业部
        for(var i=0;i<this.yybData.length;i++){
          var provice=this.yybData[i].province;
          if(!this.yybTempData[provice]){
            this.yybTempData[provice]=[];
            this.regionList.push(provice);
          }
          this.yybTempData[provice].push(this.yybData[i]);
        }
        this.$forceUpdate();
        //初始化第一个地区的营业部信息
        this.yybList=this.yybTempData[this.regionList[0]];

        //附近tab页下的营业部
        for(var i=0;i<this.yybData.length;i++){
          var distance=this.getFlatternDistance(this.yybData[i].branchWd,this.yybData[i].branchJd,parseFloat(this.wd),parseFloat(this.jd));
          this.yybData[i].distance=distance.toFixed(0);
          this.nearList.push(this.yybData[i]);
        }
        var arr=this.nearList;
        var len = this.nearList.length;
        try{
          //按照营业部距离进行排序，由近到远
          for (var i = 0; i < len-1; i++) {
            for (var j = 0; j < len - 1 - i; j++) {
                if (Number(arr[j].distance) > Number(arr[j + 1].distance)) {
                    var temp = arr[j];
                    arr[j] = arr[j+1];
                    arr[j+1] = temp;
                }
            }
          }
          this.nearList=arr;
        }catch(e){

        }
        
      }
    });
    },
    getFlatternDistance(lat1,lng1,lat2,lng2){
      var f = this.getRad((lat1+lat2)/2);
        var g = this.getRad((lat1-lat2)/2);
        var l = this.getRad((lng1-lng2)/2);

        var sg = Math.sin(g);
        var sl = Math.sin(l);
        var sf = Math.sin(f);

        var s,c,w,r,d,h1,h2;
        var a = this.EARTH_RADIUS;
        var fl = 1/298.257;

        sg = sg*sg;
        sl = sl*sl;
        sf = sf*sf;

        s = sg*(1-sl)+(1-sf)*sl;
        c = (1-sg)*(1-sl)+sf*sl;

        w = Math.atan(Math.sqrt(s/c));
        r = Math.sqrt(s*c)/w;
        d = 2*w*a;
        h1 = (3*r -1)/2/c;
        h2 = (3*r +1)/2/s;

        return d*(1+fl*(h1*sf*(1-sg)-h2*(1-sf)*sg));
    },
    getRad(d){
      var PI = Math.PI; // 去除头尾|线;
      return d*PI/180.0;
    }
  }
};
</script>
<style lang="less" >
@import "./style/yybIndex.less";
</style>
<style>
</style>